<template>
    <b-card v-if="!loading">
        <b-row>
            <b-col md="3" class="mb-2">
                <h5 class="text-primary">نام و نام خانوادگی مدیر</h5>
                <h6>{{ storeInformation.adminFirstName }} {{ storeInformation.adminLastName }}</h6>
            </b-col>
            <b-col md="3" class="mb-2">
                <h5 class="text-primary">شماره همراه</h5>
                <h6>{{ storeInformation.adminPhoneNumber }}</h6>
            </b-col>
            <b-col md="3" class="mb-2">
                <h5 class="text-primary">شناسه مجموعه</h5>
                <h6>{{ storeInformation.name_En }}</h6>
            </b-col>
            <b-col md="3" class="mb-2">
                <h5 class="text-primary">نام مجموعه</h5>
                <h6>{{ storeInformation.name_Fa }}</h6>
            </b-col>
            <b-col md="3" class="mb-2">
                <h5 class="text-primary">نام اشتراک فعال</h5>
                <h6>{{ storeInformation.subscription.title }}</h6>
            </b-col>
            <b-col md="3" class="mb-2">
                <h5 class="text-primary">تاریخ عضویت</h5>
                <h6>{{ new Date(storeInformation.registerDate).toLocaleDateString('fa-IR') }}</h6>
            </b-col>
            <b-col md="3" class="mb-2">
                <h5 class="text-primary">باقیمانده روزهای اشتراک</h5>
                <h6>{{ storeInformation.remainingSubscriptionDays }}</h6>
            </b-col>
            <b-col md="3">
                <h5 class="text-primary">رزرو اشتراک</h5>
                <feather-icon :icon="storeInformation.hasReservedSubscription ? 'CheckIcon' : 'XIcon'" size="18"
                    :class="storeInformation.hasReservedSubscription ? 'text-success' : 'text-warning'" />
            </b-col>
            <b-col xl="2" lg="4" class="mt-2">
                <b-button @click="loginStorePanel(storeInformation.adminUserId)" variant="info" class="w-100">
                    ورود به پنل
                </b-button>
            </b-col>
            <b-col xl="2" lg="4" class="mt-2">
                <b-button @click="$bvModal.show('modal-change-password')" variant="warning" class="w-100">
                    تغییر رمز عبور
                </b-button>
            </b-col>
            <b-col xl="2" lg="4" class="mt-2">
                <b-button @click="$router.push(`/sms-management-store?id=${storeId}`)" variant="primary" class="w-100">
                    تنظیمات پیامک
                </b-button>
            </b-col>
            <b-col xl="2" lg="4" class="mt-2">
                <b-button @click="$bvModal.show('subscription-renewal')" variant="primary" class="w-100">
                    تمدید اشتراک
                </b-button>
            </b-col>
            <b-col xl="2" lg="4" class="mt-2">
                <b-button @click="$bvModal.show('clear-daily-visits')" variant="danger" class="w-100">
                    حذف گزارش اسکن ها
                </b-button>
            </b-col>
            <b-col xl="2" lg="4" class="mt-2">
                <b-button @click="$bvModal.show('modal-delete-store')" variant="danger" class="w-100">
                    حذف
                </b-button>
            </b-col>
        </b-row>

        <!-------------------------------------- delete modal -------------------------------------->
        <b-modal id="modal-delete-store" title="حذف مجموعه" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <b-card-text class="p-1">
                <h5 class="text-center text-danger">آیا از حذف این مجموعه مطمئن هستید؟</h5>
                <div class="d-flex align-items-center mt-3">
                    <b-button @click="$bvModal.hide('modal-delete-store')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button @click="removeStore(storeInformation.id)" class="w-50" variant="danger">
                        حذف
                    </b-button>
                </div>
            </b-card-text>
        </b-modal>

        <!-------------------------------------- clearDailyVisits modal -------------------------------------->
        <b-modal id="clear-daily-visits" title="حذف گزارش اسکن ها" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <b-card-text class="p-1">
                <h5 class="text-center text-danger">آیا از حذف گزارش اسکن های این مجموعه مطمئن هستید؟</h5>
                <div class="d-flex align-items-center mt-3">
                    <b-button @click="$bvModal.hide('clear-daily-visits')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button @click="clearDailyVisits" class="w-50" variant="danger">
                        حذف
                    </b-button>
                </div>
            </b-card-text>
        </b-modal>

        <!-------------------------------------- change password -------------------------------------->
        <b-modal id="modal-change-password" title="تغییر رمز عبور مجموعه" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <b-card-text class="p-1">
                <p>رمز عبور جدید را وارد کنید</p>
                <div>
                    <b-form-input class="text-center" v-model="password" dir="ltr" />
                </div>
                <div class="d-flex align-items-center mt-3">
                    <b-button @click="$bvModal.hide('modal-change-password')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button @click="changeUserPassword(storeInformation.adminUserId)" class="w-50" variant="primary">
                        ذخیره
                    </b-button>
                </div>
            </b-card-text>
        </b-modal>

        <!-------------------------------------- subscription renewal -------------------------------------->
        <b-modal id="subscription-renewal" title="تمدید اشتراک مجموعه" centered :hide-footer="true"
            title-class="font-weight-bolder">
            <b-card-text class="p-1">
                <div>
                    <div class="d-flex align-items-center justify-content-center mb-3">
                        <div class="d-flex align-items-center">
                            <b-form-radio v-for="(subscription, index) in subscriptionList" :key="index" class="mr-2"
                                v-model="form.subscriptionId" :value="subscription.id">
                                {{ subscription.title }}
                            </b-form-radio>
                        </div>
                    </div>
                    <div>
                        <b-form-input class="text-center" v-model="form.totalDays" placeholder="مدت زمان اشتراک"
                            dir="ltr" />
                    </div>
                </div>
                <div class="d-flex align-items-center mt-3">
                    <b-button @click="$bvModal.hide('subscription-renewal')" class="w-50 mr-1" variant="secondary">
                        انصراف
                    </b-button>
                    <b-button @click="subscriptionRenewal(storeInformation.id)" class="w-50" variant="primary">
                        تمدید
                    </b-button>
                </div>
            </b-card-text>
        </b-modal>
    </b-card>
</template>

<script>
import { BCard, BCardText, BLink, BRow, BCol, BButton, BFormInput, BFormRadio } from 'bootstrap-vue';
import { adminService } from '@core/services';

export default {
    components: {
        BCard,
        BCardText,
        BLink,
        BRow,
        BCol,
        BButton,
        BFormInput,
        BFormRadio
    },
    data() {
        return {
            loading: true,
            storeId: null,
            storeInformation: {},
            password: null,
            form: {
                totalDays: null,
                subscriptionId: null,
            },
            subscriptionList: []
        };
    },
    methods: {
        getStore() {
            adminService.getStore(this.storeId).then(({ data }) => {
                this.storeInformation = data
                this.form.subscriptionId = this.storeInformation.subscription.id
                this.getSubscriptions()
            })
        },
        async getSubscriptions() {
            await this.$axios.get('/Subscription').then(({ data }) => {
                this.subscriptionList = data.subscriptions
                this.loading = false
            })
        },
        removeStore(id) {
            adminService.removeStore(id).then(({ data }) => {
                this.$router.push('/')
            })
        },
        loginStorePanel(id) {
            let data = {
                userId: id
            }
            adminService.loginAsUser(data).then(({ data }) => {
                window.location.href = `https://panel.menutech.ir/#/login?refreshToken=${data.refreshToken}`;
            })
        },
        changeUserPassword(id) {
            let data = {
                newPassword: this.password,
                userId: id
            }
            adminService.changeUserPassword(data).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.$bvModal.hide('modal-change-password');
                this.password = null
            })
        },
        subscriptionRenewal(id) {
            adminService.subscriptionRenewal(id, this.form).then(({ data }) => {
                this.getStore()
                this.$bvModal.hide('subscription-renewal')
                this.$notif({ type: 'success' });
                this.form.subscriptionId = null;
                this.form.totalDays = null;
            })
        },
        clearDailyVisits() {
            adminService.clearDailyVisits(this.storeId, { from: null, to: null }).then(({ data }) => {
                this.$notif({ type: 'success' });
                this.$bvModal.hide('clear-daily-visits')
            })
        },
    },
    mounted() {
        this.storeId = this.$route.query.id;
        this.getStore();
    },
};
</script>
